import { compose } from 'recompose';
import { renderNothingIfPropFalsy } from 'utils/recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import { workingStateSubmissionLoading } from 'reducers/loading/selectors';

const mapStateToProps = combineSelectors({
  saving: workingStateSubmissionLoading,
});

export default compose(
  connect(mapStateToProps),
  renderNothingIfPropFalsy('saving'),
);
